export default "__VITE_ASSET__CKLJ8Z24__"